export default [
  {
    img: `${process.env.PUBLIC_URL}/assets/img/research/doe.png`,
    title: 'U.S. Department of Education',
    description: [
      `BrainQuake was one of only 13 companies from approximately 180
      applicants to win a Department of Education Small Business Award
      Innovation Research Award to conduct research and development 
      work on our flagship app <i>Wuzzit&trade;Trouble.</i>`,
      `In May 2016, BrainQuake won a prestigious Phase II SBIR Award,
      supporting the development of two new applications, three digital
      manipulatives, patent-pending dashboard analytics and an online course
      detailing the science behind, and application of our work in, classrooms
      and homes.`,
    ],
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/img/research/stanford.png`,
    title: 'Stanford University',
    description: [
      `World-renowned mathematics education expert, Dr. Jo Boaler, led a 
      small pilot pre/post-impact comparison group study, which was 
      published in the <i>International journal of Serious Games</i>, October 2015.`,
    ],
    links: [
      {
        name: 'Download Summary',
        url:
          process.env.PUBLIC_URL +
          '/assets/pdf/Stanford-Pope_Mangram_SUMMARY.pdf',
      },
      {
        name: `Download the Paper`,
        url: process.env.PUBLIC_URL + '/assets/pdf/Stanford-Pope-Mangram.pdf',
      },
      {
        name: `Download Journal Editorial`,
        url: process.env.PUBLIC_URL + '/assets/pdf/IJSG_Editorial_2015.pdf',
      },
      {
        url:
          'https://prezi.com/kzf3ioih9fa6/holly-pope-phd/?utm_campaign=share&token=ca340fcd9c9699a5649688c156142dae22f4746de0c066ac1dfb92a7c27e391d&utm_medium=copy',
        name: "View Dr. Pope's Prezi",
      },
    ],
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/img/research/tampere.png`,
    title: 'Tampere University of Technology',
    description: [
      `A Finnish-led study explored learning and engagement in <i>Wuzzit&trade;
      Trouble</i> in middle school classes in Finland and California.
      The <i>International Journal of Serious Games</i> published the findings
      in October 2015.`,
    ],
    links: [
      {
        url: process.env.PUBLIC_URL + '/assets/pdf/Tampere-Paper.pdf',
        name: 'Download Paper',
      },
      {
        url: process.env.PUBLIC_URL + '/assets/pdf/IJSG_Editorial_2015.pdf',
        name: 'Download Journal Editorial',
      },
    ],
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/img/research/northeastern.png`,
    title: 'Northeastern University',
    description: [
      `Northeastern’s Game-Based Learning Lab analyzed anonymous
      BrainQuake data using the University’s proprietary analytics. A 2014
      paper was presented at the International Conference of the Learning
      Sciences Workshop on <i>Learning Analytics for Learning and Becoming a
      Practice (2014)</i>. A 2015 paper was published in <i>Foundations of
      Digital Games 2015</i>.`,
    ],
    links: [
      {
        name: 'Download 2014 Paper',
        url:
          process.env.PUBLIC_URL +
          '/assets/pdf/Northeastern-Nguyen_ICLS_2014.pdf',
      },
      {
        name: 'Download 2015 Paper',
        url:
          process.env.PUBLIC_URL +
          '/assets/pdf/Northeastern-Nguyen_Glyph_2015.pdf',
      },
    ],
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/img/research/wested.png`,
    title: 'WestEd',
    description: [
      `In 2015, funded by the Department of Education in connection with
      BrainQuake’s SBIR grant, the educational research nonprofit
      organization WestEd carried out an extensive study of <i>Wuzzit&trade;
      Trouble</i> usage. The new study involved six teachers and over 200 5th
      and 6th grade students across two schools in the San Francisco Bay
      Area, providing a detailed examination of the educational effectiveness
      of the game. In 2016, the Department of Education funded Phase II, 
      supporting BrainQuake to develop a robust platform of new puzzles, 
      assessment metrics and instructional tools.`,
    ],
    links: [
      {
        name: 'Download the Report',
        url:
          process.env.PUBLIC_URL + '/assets/pdf/WestEd-BrainquakeFeasMemo.pdf',
      },
      {
        name: 'Download the Phase II Report',
        url:
          'http://profkeithdevlin.com/Papers/BQ_SBIR_Feasibility_Report_2018.pdf',
      },
    ],
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/img/research/oxford.png`,
    title: 'University of Oxford',
    description: [
      `Dr. Anne Watson's <i>Pedagogy Analysis of the Introductory Learning
      of the Introductory Learning Ramp</i> in <i>Wuzzit&trade; Trouble<i>
      reviewed the deep learning principles behind the initial puzzles in
      the app.`,
    ],
    links: [
      {
        name: 'Download the Paper',
        url:
          process.env.PUBLIC_URL +
          '/assets/pdf/Oxford-Anne-Watson-analysis-of-the-WT-ramp.pdf',
      },
    ],
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/img/research/samk.png`,
    title: 'Satakunta University & Stanford University',
    description: [
      `BrainQuake’s Chief Scientist collaborated with Science Advisory Board
      member Dr. Harri Ketamo to study the feasibility of game-based
      assessment to measure national educational performance. `,
    ],
    links: [
      {
        name: 'Download the Paper',
        url: process.env.PUBLIC_URL + '/assets/pdf/SAMK-Ketamo-Devlin_2014.pdf',
      },
    ],
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/img/research/turku.jpeg`,
    title: 'University of Turku',
    description: [
      `University of Turku, Finland, Tampere University of Technology,
      Finland, and Stanford University. BrainQuake’s Chief Scientist
      collaborated with Science Advisory Board member Dr. Harri Ketamo of
      Turku University and Dr. Kristian Kiili of Tampere University of
      Technology on a study that provided evidence for the efficacy of using
      learning games to assess performance. The paper was accepted for
      presentation at the American Educational Research Association (AERA)
      National Meeting in New York City in April 2018, and was published in
      the conference proceedings.`,
    ],
    links: [
      {
        name: 'Download the Paper',
        url:
          process.env.PUBLIC_URL + '/assets/pdf/Ketamo_Devlin_Kiili_2018.pdf',
      },
    ],
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/img/research/cls.jpeg`,
    title: 'Connected Learning Summit',
    description: [
      `This paper describes a large-scale, randomized control study examining
      how BrainQuake’s suite of puzzle games impacts students’ mathematics
      achievement and attitudes. The work provides a concrete illustration of
      how understanding of deeper cognitive processing can be leveraged to
      design learning games that effectively support students in reasoning in
      mathematics.`,
    ],
    links: [
      {
        name: 'Download the Paper',
        url:
          process.env.PUBLIC_URL +
          '/assets/pdf/Atienza_CLS_Games_Based_Math_2018.pdf',
      },
    ],
  },
  {
    img: `${process.env.PUBLIC_URL}/assets/img/research/uol_bnu.png`,
    title: 'University of Lapland and Beijing Normal University',
    description: [
      `Researchers at the Centre of Media Pedagogy of the Faculty of
      Education at University of Lapland, Finland, the Faculty of Education
      at the University of Oulu, Finland, Stanford University, and the
      Learning Science Lab at the Advanced Innovation Center of Future
      Education at Beijing Normal University, China collaborated in this
      study. Conducted in China, this research examined the way math teachers
      in China incorporated BrainQuake’s product into their classroom
      instruction and the impact it had on the students’ learning.`,
    ],
    links: [
      {
        name: 'Download the Paper',
        url:
          'https://web.stanford.edu/~kdevlin/Papers/Sun_paper.pdf',
      },
    ],
  },
];
